// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"60a942e8","180":"c985e468","309":"60a942e8","383":"bf0c13b2","470":"f0296084","534":"c8d912bc","554":"528749a6","688":"2c43883f","765":"52c7c170","957":"a12b1210"}[chunkId] + ".chunk.css";
};